/* eslint-disable jsx-a11y/no-static-element-interactions */
import { h } from 'preact'
import { useState, useEffect, useRef } from 'preact/hooks'
import { useSelector } from 'react-redux'
import withSearch from '@features/elastic/core/withSearch'
import translate from '@core/translate'

function PageSizeFacet({ setPageSize, pageSizeOptions }) {
	const [isOpen, setIsOpen] = useState(null)
	const toggle = () => setIsOpen(!isOpen)

	return (
		<div className={`facets__facet ${isOpen ? '--active' : ''}`}>
			<div className="facets__label" onClick={toggle} tabIndex={0} role="button">
				<span>{translate('catalog.pageSize')}</span>

				<svg
					width="16"
					height="16"
					viewBox="0 0 48 48"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M8.36612 16.1161C7.87796 16.6043 7.87796 17.3957 8.36612 17.8839L23.1161 32.6339C23.6043 33.122 24.3957 33.122 24.8839 32.6339L39.6339 17.8839C40.122 17.3957 40.122 16.6043 39.6339 16.1161C39.1457 15.628 38.3543 15.628 37.8661 16.1161L24 29.9822L10.1339 16.1161C9.64573 15.628 8.85427 15.628 8.36612 16.1161Z"
						fill="#212121"
					/>
				</svg>
			</div>

			{isOpen && (
				<div className="facets__facet-options">
					{pageSizeOptions.map(({ selected, disabled, text }) => (
						<div className="facets__facet-option" key={text}>
							<div
								className="facets__facet-option__checkbox"
								onClick={e => {
									const radioElement = e.target.querySelector('input')
									radioElement.click()
									setPageSize(Number(radioElement.value))
								}}
							>
								<input
									type="radio"
									name="pagesize-option"
									id={`option-${text}`}
									defaultChecked={selected}
									disabled={disabled}
									data-value={text}
									value={text}
									style={{ pointerEvents: 'none' }}
								/>

								<span style={{ pointerEvents: 'none' }}>
									{translate('catalog.pagesize.perpage', text)}
								</span>
							</div>
						</div>
					))}
				</div>
			)}
		</div>
	)
}

export default withSearch(({ setPageSize, pageSize }) => ({ setPageSize }))(PageSizeFacet)
